(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accessory-addon"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__PORPHIS_ACCESSORY_ADDON_V2__) return;
  window.__PORPHIS_ACCESSORY_ADDON_V2__ = true;
  const ROOT = '[data-accessory-addon]';
  const ITEM = '[data-accessory-item]';
  const initialized = new WeakSet();
  const adapted = new WeakSet();
  const notifying = new WeakSet();
  const checkoutVisibility = new WeakMap();
  const rootsFor = form => Array.from(document.querySelectorAll(ROOT)).filter(root => root.dataset.productFormId === form.getAttribute('id'));
  const itemsFor = form => rootsFor(form).flatMap(root => Array.from(root.querySelectorAll(ITEM)));
  const selected = item => item.querySelector('[data-accessory-add-btn]').getAttribute('aria-pressed') === 'true';
  const available = item => item.dataset.accessoryAvailable !== 'false' && !item.hasAttribute('data-accessory-unpublished');
  const quantityInput = item => item.querySelector('[data-accessory-qty-input]');
  function limits(item) {
    const min = Math.max(1, Number(item.dataset.min) || 1);
    const step = Math.max(1, Number(item.dataset.step) || 1);
    const max = item.dataset.max ? Number(item.dataset.max) : Infinity;
    return {min, step, max};
  }
  function quantity(item) {
    const {min, step, max} = limits(item);
    let value = Math.max(min, Math.floor(Number(quantityInput(item).value) || min));
    value = min + Math.floor((value - min) / step) * step;
    if (value > max) value = min + Math.floor((max - min) / step) * step;
    return Math.max(0, value);
  }
  function notify(form) {
    if (!form) return;
    const hasSelected = itemsFor(form).some(selected);
    rootsFor(form).forEach(root => { root.querySelector('[data-accessory-checkout-note]').hidden = !hasSelected; });
    form.querySelectorAll('.shopify-payment-button').forEach(button => {
      if (hasSelected) {
        if (!checkoutVisibility.has(button)) checkoutVisibility.set(button, button.hidden);
        button.hidden = true;
      } else if (checkoutVisibility.has(button)) {
        button.hidden = checkoutVisibility.get(button); checkoutVisibility.delete(button);
      }
    });
    const bundles = Array.from(document.querySelectorAll('[form]')).filter(node => node.getAttribute('form') === form.getAttribute('id'))
      .flatMap(node => Array.from(node.querySelectorAll('input[name="bundles"]:checked')));
    const unique = Array.from(new Set(bundles));
    notifying.add(form);
    form.dispatchEvent(new CustomEvent('bundle:change', {detail: {items: unique.map(input => ({
      id: input.value, price: input.dataset.price || '0',
      quantity: input.hasAttribute('data-accessory-native-bundle') ? quantity(input.closest(ITEM)) : 1
    }))}}));
    notifying.delete(form);
  }
  function adaptForm(form) {
    if (!form || adapted.has(form) || typeof form.prepareFormData !== 'function') return;
    const nativePrepare = form.prepareFormData;
    form.prepareFormData = function (data) {
      const result = nativePrepare.call(this, data);
      if (!Array.isArray(result.items)) return result;
      // Concept reverses its bundles before appending the main item.
      const bundles = Array.from(this.bundles || []).reverse();
      bundles.forEach((input, index) => {
        if (!input.hasAttribute('data-accessory-native-bundle') || !result.items[index]) return;
        const item = input.closest(ITEM);
        result.items[index].quantity = quantity(item);
        const text = item.querySelector('[data-accessory-custom-text]');
        if (text?.value.trim()) result.items[index].properties = {
          ...(result.items[index].properties || {}),
          'Custom Text': text.value.trim().slice(0, 15)
        };
      });
      // The native multi-item converter omits selling_plan from its main item.
      if (data.get('selling_plan')) {
        result.items[result.items.length - 1].selling_plan = data.get('selling_plan');
        delete result.selling_plan;
      }
      return result;
    };
    form.addEventListener('bundle:change', event => {
      if (notifying.has(form)) return;
      event.stopImmediatePropagation();
      notify(form);
    }, true);
    adapted.add(form);
  }
  function sync(item) {
    item.querySelectorAll('[data-accessory-native-bundle]').forEach(input => input.remove());
    const root = item.closest(ROOT);
    const form = document.getElementById(root.dataset.productFormId);
    if (selected(item) && available(item) && quantity(item) > 0) {
      const input = document.createElement('input');
      input.type = 'checkbox'; input.name = 'bundles';
      input.value = item.querySelector('[data-accessory-hidden-id]').value;
      input.checked = true; input.hidden = true; input.tabIndex = -1;
      input.setAttribute('data-accessory-native-bundle', '');
      input.dataset.price = item.dataset.price || '0';
      item.appendChild(input);
    }
    adaptForm(form);
    notify(form);
  }
  function summary(item) {
    const box = item.nextElementSibling;
    if (!box?.matches('[data-accessory-summary]')) return;
    box.replaceChildren();
    const showSummary = selected(item) && !item.matches('.accessory-addon__item--engraving');
    box.classList.toggle('is-hidden', !showSummary);
    if (!showSummary) return;
    const line = document.createElement('div'); line.className = 'accessory-addon__summary-line';
    const label = document.createElement('span'); label.className = 'accessory-addon__summary-variant';
    const select = item.querySelector('[data-accessory-variant]');
    label.textContent = select ? select.selectedOptions[0]?.textContent.trim() : 'Selected';
    const qty = document.createElement('span'); qty.className = 'accessory-addon__summary-qty';
    qty.textContent = '×' + quantity(item);
    const remove = document.createElement('button'); remove.type = 'button';
    remove.className = 'accessory-addon__summary-remove'; remove.setAttribute('data-accessory-remove','');
    remove.setAttribute('aria-label','Remove accessory'); remove.textContent = '×';
    line.append(label, qty, remove); box.append(line);
  }
  function choose(item, active) {
    active = Boolean(active && available(item) && quantity(item) > 0);
    const button = item.querySelector('[data-accessory-add-btn]');
    button.setAttribute('aria-pressed', String(active));
    button.classList.toggle('is-hidden', active);
    item.querySelector('[data-accessory-check]').setAttribute('aria-pressed', String(active));
    item.classList.toggle('is-checked', active);
    item.querySelector('[data-accessory-qty]').classList.toggle('is-hidden', !active);
    quantityInput(item).value = active ? quantity(item) : limits(item).min;
    summary(item); sync(item);
  }
  function variant(select) {
    const item = select.closest(ITEM); const option = select.selectedOptions[0];
    if (!option) return;
    item.querySelector('[data-accessory-hidden-id]').value = option.value;
    item.dataset.accessoryAvailable = String(!option.disabled);
    for (const key of ['price', 'min', 'step', 'max']) item.dataset[key] = option.dataset[key] || '';
    const template = Array.from(item.querySelectorAll('[data-accessory-price-template]')).find(t => t.dataset.accessoryPriceTemplate === option.value);
    if (template) item.querySelector('[data-accessory-price]').replaceChildren(template.content.cloneNode(true));
    const img = item.querySelector('.accessory-addon__img');
    if (img && option.dataset.image) { img.src = option.dataset.image; img.removeAttribute('srcset'); }
    const button = item.querySelector('[data-accessory-add-btn]');
    button.disabled = !available(item); button.setAttribute('aria-disabled',String(!available(item)));
    const wasSelected = selected(item);
    quantityInput(item).value = quantity(item);
    choose(item, wasSelected);
  }
  function engravingVariant(item, showError = false) {
    const select = item.querySelector('[data-accessory-variant]');
    const groups = Array.from(item.querySelectorAll('[data-accessory-option-group]'));
    if (!select || !groups.length) return;
    const choices = groups.map(group => group.querySelector('[data-accessory-engraving-option]:checked'));
    const match = choices.every(Boolean) && Array.from(select.options).find(option =>
      choices.every(choice => option.getAttribute(`data-option-${choice.dataset.optionPosition}`) === choice.value));
    const error = item.querySelector('[data-accessory-engraving-error]');
    if (!match || match.disabled) {
      item.dataset.accessoryAvailable = 'false';
      const button = item.querySelector('[data-accessory-add-btn]');
      button.disabled = true; button.setAttribute('aria-disabled','true');
      if (error) { error.textContent = 'This engraving combination is unavailable.'; error.hidden = !showError; }
      const dialog = item.querySelector('[data-accessory-engraving-dialog]');
      if (showError && dialog && !dialog.open) dialog.showModal();
      choose(item, false);
      engravingSummary(item);
      return;
    }
    if (error) error.hidden = true;
    select.value = match.value;
    variant(select);
    engravingSummary(item);
  }
  function engravingSummary(item) {
    const summaryText = item.querySelector('[data-accessory-engraving-summary]');
    if (!summaryText) return;
    const choices = Array.from(item.querySelectorAll('[data-accessory-option-group]')).map(group =>
      group.querySelector('[data-accessory-engraving-option]:checked')?.value || 'Choose option');
    const icon = choices[1]?.toLowerCase().includes('no icon') ? 'No icon' : choices[1];
    const typed = item.querySelector('[data-accessory-custom-text]')?.value.trim().slice(0, 15);
    summaryText.textContent = [choices[0], icon, typed ? `“${typed}”` : ''].filter(Boolean).join(' · ');
  }
  function init(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const form = document.getElementById(root.dataset.productFormId);
    adaptForm(form);
    root.querySelectorAll(ITEM).forEach(item => {
      quantityInput(item).value = limits(item).min;
      const select = item.querySelector('[data-accessory-variant]');
      if (select) variant(select);
      if (item.matches('.accessory-addon__item--engraving')) engravingVariant(item);
      choose(item, root.dataset.accessoryDefaultChecked === 'true');
    });
  }
  function scan(scope) {
    if (scope.matches?.(ROOT)) init(scope);
    scope.querySelectorAll?.(ROOT).forEach(init);
  }
  document.addEventListener('click', event => {
    const engravingAction = event.target.closest?.('[data-accessory-engraving-open], [data-accessory-engraving-close], [data-accessory-engraving-done]');
    if (engravingAction?.closest(ROOT)) {
      event.preventDefault();
      const dialog = engravingAction.closest(ITEM).querySelector('[data-accessory-engraving-dialog]');
      if (engravingAction.matches('[data-accessory-engraving-open]')) {
        if (!dialog.open) dialog.showModal();
      } else if (dialog.open) dialog.close();
      return;
    }
    const button = event.target.closest?.('[data-accessory-add-btn], [data-accessory-check], [data-accessory-remove], [data-accessory-qty] button');
    if (!button || !button.closest(ROOT)) return;
    event.preventDefault();
    let item = button.closest(ITEM);
    if (button.matches('[data-accessory-check]')) {
      choose(item, false);
    } else if (button.matches('[data-accessory-remove]')) {
      item = button.closest('[data-accessory-summary]')?.previousElementSibling;
      if (item) choose(item, false);
    } else if (button.matches('[data-accessory-add-btn]')) {
      if (!button.disabled) choose(item, true);
    } else if (item) {
      const {min, step, max} = limits(item);
      let value = quantity(item) + (button.name === 'minus' ? -step : step);
      if (value < min) return choose(item, false);
      quantityInput(item).value = Math.min(max, value);
      choose(item, true);
    }
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches?.('[data-accessory-variant]')) variant(input);
    else if (input.matches?.('[data-accessory-engraving-option]')) engravingVariant(input.closest(ITEM), true);
    else if (input.matches?.('[data-accessory-qty-input]')) {
      const item = input.closest(ITEM);
      if (!Number.isFinite(Number(input.value)) || Number(input.value) <= 0) choose(item, false);
      else { input.value = quantity(item); choose(item, selected(item)); }
    }
  });
  document.addEventListener('input', event => {
    if (event.target.matches?.('[data-accessory-custom-text]')) engravingSummary(event.target.closest(ITEM));
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const roots = rootsFor(form);
    if (!roots.length) return;
    const selectedItems = itemsFor(form).filter(selected);
    for (const item of selectedItems) {
      if (Number(quantityInput(item).value) <= 0) choose(item, false);
      else { quantityInput(item).value = quantity(item); sync(item); }
    }
    adaptForm(form);
    if (itemsFor(form).some(selected) && !adapted.has(form)) {
      event.preventDefault(); event.stopImmediatePropagation();
      const error = roots[0].querySelector('[data-accessory-error]');
      error.hidden = false; error.textContent = 'Please reload this page before adding accessories.';
    }
  }, true);
  function start() {
    scan(document);
    customElements.whenDefined('product-form').then(() => document.querySelectorAll(ROOT).forEach(root => adaptForm(document.getElementById(root.dataset.productFormId))));
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) scan(node);
    }).observe(document.body, {childList:true, subtree:true});
    document.addEventListener('variant:change', () => document.querySelectorAll(ROOT).forEach(root => notify(document.getElementById(root.dataset.productFormId))), true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker-engraving"] && !Shopify.designMode) return;
  try {
    // Resolve the real variant from the checked engraving options immediately
  // before the native Concept product form builds its add-to-cart request.
  (function () {
    if (window.__porphisEngravingVariantSubmitGuardV3) return;
    window.__porphisEngravingVariantSubmitGuardV3 = true;

    document.addEventListener('submit', function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('form[is="product-form"]')) return;

      const picker = Array.from(document.querySelectorAll('variant-picker[data-engraving-form-id]'))
        .find(node => node.dataset.engravingFormId === form.getAttribute('id'));
      if (!picker) return;

      const customText = Array.from(form.elements).find(node => node.hasAttribute?.('data-engraving-custom-text'));
      if (customText) customText.value = customText.value.slice(0, 15);

      if (picker.hasAttribute('data-engraving-unpublished')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        form.handleErrorMessage?.('This product has not been published. Set its status to Active and publish it to Online Store before adding it to cart.');
        return;
      }

      const groups = Array.from(picker.querySelectorAll('fieldset[data-option-index]'));
      const selections = groups.map(group => group.querySelector('input[type="radio"]:checked')?.value);
      let variants = [];
      try { variants = JSON.parse(picker.querySelector('[data-variants]')?.textContent || '[]'); } catch (_) {}

      const variant = groups.length === selections.length && selections.every(Boolean)
        ? variants.find(item => selections.every((value, index) => item[`option${index + 1}`] === value))
        : null;
      if (!variant?.id || !variant.available) {
        event.preventDefault();
        event.stopImmediatePropagation();
        form.handleErrorMessage?.('Please choose an available engraving option.');
        return;
      }

      let idInput = form.querySelector('input[name="id"]');
      if (!idInput) {
        idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        form.appendChild(idInput);
      }
      idInput.value = String(variant.id);
      idInput.disabled = false;
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
